import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Partners, Banner, Process, NewsletterSection, Awards } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Banner />
        <Process />
        <Testimonials />
        <Team />
        <NewsletterSection />
        <Awards />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;